import { render } from "./CRMsource.vue?vue&type=template&id=c7d4994e&scoped=true"
import script from "./CRMsource.vue?vue&type=script&lang=js"
export * from "./CRMsource.vue?vue&type=script&lang=js"

import "./CRMsource.vue?vue&type=style&index=0&id=c7d4994e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c7d4994e"

export default script